/**
 * Šta reći vozaču kad nema veze, a tura se ne može učitati.
 *
 * Analiza 2.0 (D12), 14.10.2026: tura u telefonu se prihvata samo ako je
 * učitana OVIM linkom (deljen telefon — vozač ne sme da vidi tuđe kupce). Kad
 * operater usred ture napravi nov link, stari ključ prestaje da važi; otvoren
 * bez signala, nov link krije turu koja u telefonu stoji — a poruka je glasila
 * „turu učitaj dok imaš signal, pre polaska", kao da je nema.
 *
 * Tura se i dalje ne pokazuje (ne zna se čija je dok server ne kaže), ali se
 * kaže istina: tura postoji, otvorena drugim linkom.
 */
export function porukaBezVeze(args: { imaKesiranuTuru: boolean; kljucSeRazlikuje: boolean }): string {
  if (args.imaKesiranuTuru && args.kljucSeRazlikuje) {
    return 'Nema veze sa serverom. Na telefonu je sačuvana tura otvorena DRUGIM linkom: '
      + 'ako je tvoja, otvori je starim linkom ili osveži ovaj čim bude signala; '
      + 'tuđu turu ovaj link ne otvara.';
  }

  return 'Nema veze sa serverom. Turu učitaj dok imaš signal, pre polaska.';
}
